import { PlanService } from 'src/app/data/repository/plan-repository/plan.service';
import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-exercise-table',
  templateUrl: './exercise-table.component.html',
  styleUrls: ['./exercise-table.component.scss'],
})
export class ExerciseTableComponent implements OnInit {
  @Input() calories: number = 0;
  constructor(private planService: PlanService) {}

  ngOnInit() {}
  goToExercise() {
    this.planService.goToExercise();
  }
}
